const cleareLocalStorage = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('expiresIn');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('eshopKey');
    localStorage.removeItem('eshopName');
};

export default cleareLocalStorage;
